import axios from '@/plugins/axios';

export default {
    namespaced: true,

    state: {
        entities: [],
        entitiesCount: 0,
        entity: {}
    },

    mutations: {
        SET_ENTITIES(state, payload) {
            state.entities = payload;
        },
        SET_ENTITY(state, payload) {
            state.entity = payload;
        },
        CLEAR_ENTITY(state) {
            state.entity = {};
        },
    },

    actions: {
        async fetch({ commit }, { site_id, filter = {}, sorting = null }) {
            const { data } = await axios.get(`/admin/sites/${ site_id }/products`, { params: { filter, sorting } });
            commit('SET_ENTITIES', data);
            return data;
        },
        async get({ commit }, { site_id, id }) {
            const { data } = await axios.get(`/admin/sites/${ site_id }/products/${ id }`);
            commit('SET_ENTITY', data);
        },
        async save({ commit, state }, { site_id }) {
            let response = {};
            if(state.entity.id) {
                response = await axios.put(`/admin/sites/${ site_id }/products/${ state.entity.id }`, state.entity);
            } else {
                response = await axios.post(`/admin/sites/${ site_id }/products`, state.entity);
            }
            return response.data;
        },
        async update({ commit, state }, { site_id, product }) {
            await axios.put(`/admin/sites/${ site_id }/products/${ product.id }`, product);
        },
        async delete({ commit }, { site_id, id }) {
            await axios.delete(`/admin/sites/${ site_id }/products/${ id }`);
        },
    },

    getters: {}
}
